// 🎃 10-07 pumpkins (P7): the porch, fetched LAZILY (never on the status poll): only while the carving sheet or
// the porch picture is open (`wanted`), again when the room hears {type:'house_pumpkin'} (the page bumps
// `tick`), and after your own carve or hide (`refresh`). Everything keys on the status rider house.pumpkins
// being present: absent (HOUSE_PUMPKINS_ENABLED off, or outside the window) = the page passes wanted: false and
// nothing is fetched, so the page is today's page.
import { useCallback, useEffect, useRef, useState } from 'react';
import { fetchPorch } from '../utils/pumpkinApi';

export function useHousePumpkins({ gameId, playerId, playerSecret, wanted, tick = 0 }) {
  const [state, setState] = useState({ porch: null, loading: false, error: null });
  const seq = useRef(0);
  const load = useCallback(async (page = null) => {
    if (!gameId) return null;
    const n = ++seq.current; // only the newest answer lands: a slow old read never overwrites a fresh one
    setState((s) => ({ ...s, loading: true }));
    try {
      const porch = await fetchPorch({ gameId, playerId, playerSecret, page });
      if (n === seq.current) setState({ porch, loading: false, error: null });
      return porch;
    } catch (e) {
      if (n === seq.current) setState((s) => ({ ...s, loading: false, error: (e && e.message) || 'The porch did not load.' }));
      return null;
    }
  }, [gameId, playerId, playerSecret]);
  useEffect(() => {
    if (wanted) load();
  }, [wanted, tick, load]);
  return { ...state, refresh: load };
}
